export default __webpack_public_path__ + "static/media/1.70bfa970.png";